const ICON_COLOR = "#1753FF";

const DATE_FORMAT = "MM.dd.yyyy";

export { ICON_COLOR, DATE_FORMAT };
